import styled from "@emotion/styled";

export const MainContainer = styled.div``;

export const CardContainer = styled.div`
  max-inline-size: 280px;
  padding-block: 16px;

  border-block-end: 1px solid #e5e5e5;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 20px 16px;
    padding-inline: 0 12px;

    &:first-child {
      padding-block: 0 16px;
      padding-inline: 0 12px;
    }
  }
`;
